// src/components/FooterNav.tsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { BottomNav } from './layout';
import { Box, ButtonLink, FlexLink, Text } from './ui';

interface FooterNavProps {
  className?: string; // Add className prop
}

const FooterNav: React.FC<FooterNavProps> = ({ className }) => {
  const { author } = useAuth();

  return (
    <BottomNav className={className}>
      <FlexLink
        to="/favorites"
        direction="column"
        align="center"
        textColor="white"
        textDecoration="none"
        style={{ flex: 1, minWidth: '80px', textAlign: 'center' }}
        title="Mes coups de ❤️"
      >
        <Text as="span" fontSize={5}>❤️</Text>
        <Text as="small">Favoris</Text>
      </FlexLink>

      <ButtonLink
        to="/add-recipe"
        variant="success"
        radius="circle"
        shadow
        padding={0}
        style={{ 
          width: '70px', 
          height: '70px', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          transform: 'translateY(-30%)', // Lift the button slightly
          border: '3px solid white', // Add a border to make it pop
        }}
        title="Ajouter une recette"
      >
        <Text as="span" fontSize={2}>+</Text>
      </ButtonLink>

      {author ? (
        <FlexLink
          to="/profile"
          direction="column"
          align="center"
          textColor="white"
          textDecoration="none"
          style={{ flex: 1, minWidth: '80px', textAlign: 'center' }}
          title="Mon Profil"
        >
          <Text as="span" fontSize={5}>👤</Text>
          <Text as="small">Profil</Text>
        </FlexLink>
      ) : (
        // Placeholder or login prompt if not authenticated, or simply hide
        <Box data-testid="placeholder" style={{ flex: 1 }} /> // Keep the spacing even if not authenticated
      )}
    </BottomNav>
  );
};

export default FooterNav;
